// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #ffffff;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
}

/* header {
  background-color: #f1f1f1;
  padding: 20px;
  text-align: center;
} */

h1 {
  margin: 0;
}

main {
  margin: 20px;
  margin-left: 0;
  text-align: center;
}

p {
  margin-bottom: 20px;
}

a {
  color: #000000;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

i {
  color: orange;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmbeddedChart.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;;;;GAIG;;AAEH;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB","sourcesContent":["body {\r\n  background-color: #ffffff;\r\n  font-family: Arial, sans-serif;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* header {\r\n  background-color: #f1f1f1;\r\n  padding: 20px;\r\n  text-align: center;\r\n} */\r\n\r\nh1 {\r\n  margin: 0;\r\n}\r\n\r\nmain {\r\n  margin: 20px;\r\n  margin-left: 0;\r\n  text-align: center;\r\n}\r\n\r\np {\r\n  margin-bottom: 20px;\r\n}\r\n\r\na {\r\n  color: #000000;\r\n  text-decoration: none;\r\n}\r\n\r\na:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\ni {\r\n  color: orange;\r\n  font-style: normal;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
